<template>
  <el-dialog
    :visible.sync="visibleProxy"
    :title="hasCurrentPackage ? 'Đổi gói cho trường' : 'Gán gói cho trường'"
    width="580px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div v-if="schoolRow" class="ps-school-context">
      <div class="ps-school-avatar"><i class="el-icon-school" /></div>
      <div>
        <strong>{{ schoolRow.school.name }}</strong>
        <span>{{ schoolRow.school.id }} · {{ schoolRow.currentStudents | formatNumber }} học sinh đang học</span>
      </div>
    </div>

    <el-form ref="assignForm" :model="form" :rules="rules" label-position="top" class="ps-dialog-form">
      <el-form-item label="Gói áp dụng" prop="packageId">
        <el-select v-model="form.packageId" class="ps-full-width" filterable placeholder="Chọn gói đang sử dụng">
          <el-option
            v-for="item in packages"
            :key="item.id"
            :label="`${item.code} · ${item.name}`"
            :value="item.id"
          >
            <div class="ps-option-row">
              <span><b>{{ item.code }}</b> · {{ item.name }}</span>
              <span class="ps-option-limit">Số lượng tối đa: {{ item.limit | formatNumber }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div v-if="selectedPackage" class="ps-assignment-preview">
      <div class="ps-preview-item">
        <span>Giới hạn cơ bản mới</span>
        <b>{{ selectedPackage.limit | formatNumber }} học sinh</b>
      </div>
      <div class="ps-preview-item">
        <span>Giới hạn hiệu lực sau khi gán</span>
        <b>{{ selectedPackage.limit | formatNumber }} học sinh</b>
      </div>
    </div>

    <el-alert
      v-if="hasCurrentPackage && form.packageId !== schoolRow.assignment.packageId"
      class="ps-dialog-alert"
      type="warning"
      :closable="false"
      show-icon
      title="Đổi gói sẽ tạo một lần áp dụng mới. Số lượng thêm của gói hiện tại không chuyển sang gói mới."
    />
    <el-alert
      v-if="selectedPackage && schoolRow && schoolRow.currentStudents > selectedPackage.limit"
      class="ps-dialog-alert"
      :type="schoolRow.allowExceedStudentLimit ? 'warning' : 'error'"
      :closable="false"
      show-icon
      :title="schoolRow.allowExceedStudentLimit
        ? 'Số học sinh hiện tại đang lớn hơn giới hạn mới. Cấu hình cho phép trường tiếp tục thêm học sinh vượt giới hạn.'
        : 'Số học sinh hiện tại đang lớn hơn giới hạn mới. Các lượt thêm học sinh tiếp theo sẽ bị chặn cho đến khi số học sinh đang học không vượt quá giới hạn mới.'"
    />

    <span slot="footer" class="ps-dialog-footer">
      <el-button @click="visibleProxy = false">Hủy</el-button>
      <el-button type="primary" :loading="saving" @click="handleConfirm">
        <i class="el-icon-check" /> {{ hasCurrentPackage ? 'Xác nhận đổi gói' : 'Xác nhận gán gói' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AssignPackageDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    schoolRow: {
      type: Object,
      default: null,
    },
    packages: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: { packageId: "" },
      rules: {
        packageId: [{ required: true, message: "Vui lòng chọn gói", trigger: "change" }],
      },
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    hasCurrentPackage() {
      return Boolean(this.schoolRow && this.schoolRow.assignment);
    },
    selectedPackage() {
      return this.packages.find((item) => item.id === this.form.packageId);
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.form.packageId = this.schoolRow && this.schoolRow.package
          ? this.schoolRow.package.id
          : "";
        this.$nextTick(() => {
          if (this.$refs.assignForm) {
            this.$refs.assignForm.clearValidate();
          }
        });
      }
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.assignForm.validate((valid) => {
        if (valid && this.schoolRow) {
          this.$emit("submit", {
            schoolId: this.schoolRow.school.id,
            packageId: this.form.packageId,
          });
        }
      });
    },
  },
};
</script>
